import * as React from "react";

const FilterColumns = (props: any) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path
      d="M19.193 6.769l-5.232 8.5v3.923L10.039 20.5v-5.231l-5.232-8.5h14.386zM19.19 3.5H4.81c-1.227 0-1.881 2.614-.654 2.614h15.688c1.227 0 .575-2.614-.654-2.614z"
      fillRule="nonzero"
    />
  </svg>
);

export default FilterColumns;

